import { render, staticRenderFns } from "./AddressesOverview.vue?vue&type=template&id=ebf7ac54&scoped=true"
import script from "./AddressesOverview.vue?vue&type=script&lang=ts"
export * from "./AddressesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf7ac54",
  null
  
)

export default component.exports